<template>
  <div>
    {{ !no ? '没有设备号，请联系管理员'  :'' }}
  </div>
</template>

<script>
export default {
  data () {
    return {
      no: null
    }
  },

  created () {
    // 找个页面是做免登录用的
    const query = this.$route.query
    console.log("query:", query);
    this.no = query?.no
    query?.no && this.doLogin(query?.no || null)
  },

  methods: {
    // 执行登录
    doLogin (deviceNo) {
      var loginName = 'show'
      var loginPwd = 'show123!'
      var _this = this
      _this.$toast.loading({
        message: this.$t('login.login_loading'),
        forbidClick: true,
        duration: 0,
      })
      // H5登录
      this.$api.doLogin({
        loginName: loginName,
        loginPwd: _this.$md5(loginPwd),
      }).then((res) => {
        _this.$toast.clear()
        if (res.errcode == 0) {
          localStorage.setItem('token', res.token)
          localStorage.setItem('username', loginName)
          deviceNo && localStorage.setItem("no", deviceNo)
          // 表示是免登录入口进来的
          sessionStorage.setItem('isView', true)
          _this.$router.push({ path: '/live' })
        } else {
          _this.$toast(res.errmsg)
        }
      })
        .catch((err) => {
          // 其他异常
          _this.$toast.clear()
          // _this.$toast("连接超时");
        })
    },
  }
}
</script>

<style>
</style>
